import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * Atalho para a folha de pedido da 99 (`ride99_link`, #6889) — o mobility o emite quando o
 * cliente pede uma corrida imediata ("chamar um 99") e a 99 está liberada para ele. O botão
 * despacha `open-ride99` (client-side): abre a folha do pedido, ou a da corrida em andamento.
 */
export const Ride99LinkBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('ride99_link'),
  })
  .strict();
export type Ride99LinkBlock = z.infer<typeof Ride99LinkBlockSchema>;
